var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56754 0.346793C7.71638 -0.1156 8.3706 -0.115601 8.51944 0.346792L10.0732 5.17372C10.1397 5.3804 10.332 5.52052 10.5491 5.52052H15.5871C16.0703 5.52052 16.2724 6.13794 15.8828 6.42371L11.799 9.41867C11.6254 9.54599 11.5527 9.77013 11.6187 9.97507L13.1767 14.8151C13.3252 15.2766 12.796 15.6582 12.405 15.3715L8.33919 12.3897C8.16319 12.2606 7.9238 12.2606 7.7478 12.3897L3.68195 15.3715C3.29101 15.6582 2.76176 15.2766 2.9103 14.8151L4.46827 9.97507C4.53424 9.77013 4.46162 9.54599 4.28801 9.41867L0.204215 6.42371C-0.185455 6.13794 0.0166804 5.52052 0.499908 5.52052H5.53784C5.75496 5.52052 5.94726 5.3804 6.01379 5.17372L7.56754 0.346793Z",
    fill: "#FCC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4);
export default __webpack_public_path__ + "static/media/star-4.1950004533e193880d36506634a83bdc.svg";
export { ForwardRef as ReactComponent };